/**
 * Create floating particles animation
 */
export function createParticles() {
  const particlesContainer = document.getElementById('particles')
  if (!particlesContainer) return

  // Clear existing particles
  particlesContainer.innerHTML = ''

  for (let i = 0; i < 20; i++) {
    const particle = document.createElement('div')
    particle.className = 'particle'
    particle.style.left = Math.random() * 100 + '%'
    particle.style.animationDelay = Math.random() * 15 + 's'
    particle.style.animationDuration = (15 + Math.random() * 10) + 's'
    particlesContainer.appendChild(particle)
  }
}
